module.exports = __webpack_public_path__ + "img/us2.2260f529.jpg";